import api from "./api";

export const registerUser = async (payload: RegisterPayload) => {
  return (await api.post(`/Authorization/register`, payload))
    ?.data as RegisterResponse;
};

export const loginUser = async (payload: LoginPayload) => {
  return (await api.post(`/Authorization/login`, payload))
    ?.data as LoginResponse;
};

export const getAllApplicationBatch = async () => {
  return (await api.get(`/Utilities/Utilities/GetAllApplicationBatch`))
    .data as applicationBatchResponse;
};

export const getAllModeOfStudy = async () => {
  return (await api.get(`/Utilities/Utilities/GetAllModeOfStudy`))
    ?.data as modeOfStudyResponse;
};

export const getAllPrograms = async () => {
  return (await api.get(`/Academics/GetAllProgramAsync`))
    ?.data as getAllProgramResponse;
};

export const forgotPassword = async (payload: ForgotPasswordPayload) => {
  return (await api.post(`/Authorization/ForgotPasswordAsync`, payload))?.data;
};

export const resetPassword = async (payload: ResetPasswordPayload) => {
  return (await api.post(`/Authorization/reset-password`, payload))?.data;
};

export const verifyEmail = async (userId: string, token: string) => {
  return (
    await api.get(`/Authorization/verify-email?userId=${userId}&token=${token}`)
  )?.data;
};

export const changePassword = async (payload: ChangePasswordPayload) => {
  return (await api.post(`/Authorization/ChangePassword`, payload))?.data;
};
